module.exports = __webpack_public_path__ + "img/lines.895ff1e2.png";